import store from "../store"

function getQtdeCasasDecimais () {
  const { CASAS_DECIMAIS_CARRINHO } = store.getters["configuracoes/carrinho"]

  return  CASAS_DECIMAIS_CARRINHO
}

export const QTDE_DECIMAIS = getQtdeCasasDecimais()
